module.exports = __webpack_public_path__ + "img/Carnotaurus_Fossil.85150c70.jpg";